export default __webpack_public_path__ + "static/ActivityCardNordstrand-4626e4425d9160bb20fa40739efa89d9.png";